export const TRENDS_BEAT_TEMPLATES = [
  'BillAmountNotStandard',
  'CategorySpendingV2',
  'CostOfLivingToIncome',
  'DebtPaymentReminderV2',
  'DiscoveredAccounts',
  'DuplicatePaymentV2',
  'FeeDetected',
  'GreenGasPurchasesSummary',
  'LargeTransaction',
  'LowAccountBalance',
  'MonthlyDebtToIncomeComparisonV2',
  'MonthlyDepositSummaryV2',
  'MonthlyNonEssentialCategorySummaryV2',
  'MonthlySavingsToIncomeComparison',
  'MonthlySpendToIncomeComparisonV2',
  'MonthlySubscriptionAggregateV2',
  'MonthlyTopMerchantSpendingV3',
  'MonthlyObligationsStatus',
  'QuarterlySummary',
  'SaveAnExtra100Dollars',
  'SaveEnoughToLiveOn',
  'SavingsOpportunityV2',
  'SubscriptionDetected',
  'SubscriptionPriceIncrease',
  'SetUpDirectDeposit',
  'SwitchDirectDeposit',
  'UnexpectedSubscriptionPayment',
  'UpcomingBill',
  'UpcomingSubscription',
  'WeekendSpendingSummaryV2',
  'WeeklyNewMerchantsV2',
  'WeeklyNoSpendDays',
  'WeeklySmallPurchasesSummary',
]
